<div class="inline-flex flex-col items-center gap-2 w-28">
    <div class="relative">
        <button
            class="button-basemap border-2 border-transparent footer-shadow bg-transparent hover:border-custom-blue group"
            type="button"
            [class.border-custom-blue]="selected()"
            (click)="pressed.emit()">
            <div class="w-full h-full relative">
                @if (!isBackground()) {
                    <img
                        alt=""
                        class="w-full h-full object-cover"
                        [src]="BASEMAPS_CATALOG[type()].thumbnail!" />
                } @else {
                    <div
                        class="w-full h-full"
                        [style.background]="BASEMAPS_CATALOG[type()].color"></div>
                }
            </div>

            @if (showHoverUpdate() && selected()) {
                <div class="absolute inset-0 bottom-0 pointer-events-none"></div>
                <div class="hovered-message bg-custom-light-blue text-custom-blue">
                    {{ 'update' | transloco }}
                </div>
            }
        </button>

        @if (showTrash()) {
            <button
                class="button-trash focus:outline-none focus-visible:ring-2 focus-visible:ring-black/60"
                type="button"
                [matTooltip]="'remove' | transloco"
                (click)="$event.stopPropagation(); trash.emit()">
                <fa-icon
                    size="lg"
                    [icon]="['fas', 'trash']" />
            </button>
        }
    </div>

    <div class="w-full text-center flex flex-col justify-center items-center gap-1">
        <div
            class="text-base font-medium"
            [class.hover:text-custom-blue]="!opacityReadOnly()">
            {{ `${labelKeyPrefix()}.${type()}` | transloco }}
        </div>

        @if (showOpacity()) {
            <div class="flex items-center justify-center gap-1">
                <input
                    class="percentage-input"
                    [class.bg-background]="opacityReadOnly()"
                    [class.cursor-not-allowed]="opacityReadOnly()"
                    [class.hover:text-custom-extra-dark-grey]="opacityReadOnly()"
                    [class.text-custom-dark-grey]="opacityReadOnly()"
                    [matTooltip]="opacityReadOnly() ? ('opacityNotEditable' | transloco) : null"
                    [readOnly]="opacityReadOnly()"
                    [value]="percentage()"
                    (change)="handleOpacityInput($event)" />
            </div>
        }
    </div>
</div>
